import 'core-js/es/array';

export default class Animation {

    constructor() {

        if (!window.IntersectionObserver) return;

        this.options = {
            rootMargin: '0px',
            threshold: "0",
        };

        window.addEventListener('load', () => {

            this.animations = Array.from(document.querySelectorAll('.js-ani'));
            this.jsNums = Array.from(document.querySelectorAll('.js-num'));
            this.heroArticles = Array.from(document.querySelectorAll('.c-hero-banner__article'));
            this.heroContent =  document.getElementById('js-hero-content');

            console.log(this.animations);

            document.documentElement.className += ' js-loaded';
            if (this.animations) this.bindComponentAnimations();
            if (this.jsNums) this.bindNumberAnimations();

            if (this.heroArticles) this.heroScroll(this.heroArticles);
            if (this.heroContent) this.heroContentScroll(this.heroContent);

            this.downBtn = document.getElementById('js-down-btn');
            if (this.downBtn) this.bindDownBtn();
        });

        

    }

    bindDownBtn() {

        this.downBtn.addEventListener('click', (ev) => {

            const sections = document.querySelectorAll('.c-section');

            if (sections[0]) {
                sections[0].scrollIntoView();
                sections[0].focus();
            }

        });

    }

    bindComponentAnimations() {

        const observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    setTimeout(() => { entry.target.classList.add('c-ani--animate'); }, 500);

                }

            });

        }, this.options);

        if (!!window.IntersectionObserver) {
            this.animations.forEach(el => { observer.observe(el); });
        } 

    }

    bindNumberAnimations() {

        const observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    this.animateValue(entry);

                }

            });

        }, this.options);

        if (!!window.IntersectionObserver) {
            this.jsNums.forEach(el => { observer.observe(el); });
        } 

    }

    animateValue(el) {
        // assumes integer values for start and end

        var obj = el.target;

        if(obj.dataset.finished) return;

        const start = obj.dataset.from;
        const end = obj.dataset.to;
        const duration = obj.dataset.duration || 2000;

        const range = end - start;
        // no timer shorter than 50ms (not really visible any way)
        const minTimer = 50;
        // calc step time to show all interediate values
        let stepTime = Math.abs(Math.floor(duration / range));

        // never go below minTimer
        stepTime = Math.max(stepTime, minTimer);

        // get current time and calculate desired end time
        const startTime = new Date().getTime();
        const endTime = startTime + duration;
        let timer;

        function run() {
            var now = new Date().getTime();
            var remaining = Math.max((endTime - now) / duration, 0);
            var value = Math.round(end - (remaining * range));
            obj.innerHTML = value;
            if (value == end) {
                obj.dataset.finished = true;
                clearInterval(timer);
            }
        }

        timer = setInterval(run, stepTime);
        run();
    }

    heroScroll(articles){
        if(window.innerWidth > 1200){
            articles.forEach((article, index) => {
                let totalHeight = (window.innerHeight / 2) + ((index + 1) * 100);
                article.style.transform = `translateY(${totalHeight}px)`;
            })
        }
        window.addEventListener('scroll', () => {
            if(window.innerWidth > 1200){
                articles.forEach((article, index) => {
                    let totalHeight = (window.innerHeight / 2) + ((index + 1) * 100);
                    if(scrollY > 0 && scrollY < (totalHeight + 400)){
                        let translateHeight = totalHeight - (window.scrollY - ((index + 1) * 100));
                        if(translateHeight < 0) translateHeight = 0;
                        article.style.transform = `translateY(${translateHeight}px)`;
                    }
                });
            }else{
                articles.forEach((article) => {
                    article.style.transform = `translateY(0px)`;
                });
            }
        });

        window.addEventListener('resize', () => {
            if(window.innerWidth < 1200){
                articles.forEach((article) => {
                    article.style.transform = `translateY(0px)`;
                });
            }else{
                articles.forEach((article, index) => {
                    let totalHeight = (window.innerHeight / 2) + ((index + 1) * 100);
                    article.style.transform = `translateY(${totalHeight}px)`;
                });
            }
        });
    }

    heroContentScroll(content){
        let initialTop = parseInt(getComputedStyle(content).top, 10) || 0;
        const maxScroll = window.innerHeight / 3; // Adjust for desired scroll range

        // Update initial top on resize
        window.addEventListener('resize', () => {
            initialTop = parseInt(getComputedStyle(content).top, 10) || 0;
            if (window.innerWidth < 1200) {
                content.removeAttribute("style");
            }
        });

        // Scroll event to update top and transform dynamically
        window.addEventListener("scroll", () => {
            const scrollOffset = window.scrollY;

            if (scrollOffset > 0 && scrollOffset < maxScroll) {
                if (window.innerWidth >= 1200) {
                    // Calculate a progress ratio for smooth transition from 0 to maxScroll
                    const progress = scrollOffset / maxScroll;

                    // Calculate translateY dynamically from -50% to 0% based on progress
                    const translateY = -50 * (1 + (progress * 0.6)); // Goes from -50% to -100%
                    content.style.transform = `translateY(${translateY}%)`;

                } else {
                    content.removeAttribute("style");
                }
            }   else if (scrollOffset >= maxScroll && window.innerWidth >= 1200) {
                // Ensure the final state is exactly 0 when scrolling past maxScroll
                content.style.transform = `translateY(-80%)`;
            }
        });
    }



}